// Visual Narrative Maker用の定数定義

export const NARRATIVE_CONSTANTS = {
  // 画像生成設定
  IMAGE_GENERATION: {
    MODEL_VERSION: 'image4_standard',
    NUM_VARIATIONS: 4,
    DEFAULT_SIZE: {
      height: 1536,
      width: 2688
    },
    DEFAULT_VISUAL_INTENSITY: 2,
    MIN_VISUAL_INTENSITY: 2,
    MAX_VISUAL_INTENSITY: 10
  },

  // 動画生成設定
  VIDEO_GENERATION: {
    LOCALE_CODE: 'ja_JP',
    DEFAULT_SIZE: {
      height: 540,
      width: 960
    },
    GENERATION_DELAY_MS: 2000,
    POLLING_INTERVAL_MS: 3000,
    MAX_POLLING_ATTEMPTS: 60,
    SIZES: {
      '540p': { width: 960, height: 540 },
      '720p': { width: 1280, height: 720 },
      '1080p': { width: 1920, height: 1080 }
    } as Record<string, { width: number; height: number }>
  },

  // スタイル設定
  STYLE: {
    DEFAULT_STRENGTH: 100,
    MIN_STRENGTH: 1,
    MAX_STRENGTH: 100
  },

  // ファイル設定
  FILE: {
    MAX_SIZE_MB: 10,
    ACCEPTED_IMAGE_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'],
    ACCEPTED_CSV_TYPES: ['text/csv', 'application/csv']
  },

  // UI設定
  UI: {
    MIN_SCENES: 1,
    DEFAULT_SCENES: 5,
    MIN_SCENES_FOR_CSV: 4,
    TOAST_DURATION_MS: 5000
  },

  // エラーメッセージ
  ERROR_MESSAGES: {
    NO_SCENES: 'シーンがありません',
    CSV_EMPTY: 'CSVファイルが空です',
    CSV_NO_PROMPT_HEADER: 'CSVには「prompt」ヘッダーが必要です',
    CSV_INVALID_FORMAT: 'CSVファイルのフォーマットが不正です',
    FILE_TYPE_INVALID: '非対応のファイル形式です',
    FILE_SIZE_TOO_LARGE: 'ファイルサイズが大きすぎます（上限10MB）',
    IMAGE_GENERATION_FAILED: '画像生成に失敗しました',
    VIDEO_GENERATION_FAILED: '動画生成に失敗しました',
    VIDEO_COMBINATION_FAILED: '動画の結合に失敗しました',
    UPLOAD_FAILED: 'ファイルのアップロードに失敗しました',
    ALL_SCENES_NOT_GENERATED: 'すべてのシーン画像が生成されていません',
    NO_GENERATED_IMAGES: '生成された画像が見つかりません',
    MIN_VIDEOS_FOR_COMBINE: '結合するには少なくとも2つの動画が必要です',
    MIN_SCENES_REQUIRED: '少なくとも1つのシーンが必要です',
    NO_COMBINED_VIDEO: '編集する動画がありません',
    NO_SCENE_IMAGE_SELECTED: 'シーンの画像が選択されていません'
  },

  // 成功メッセージ
  SUCCESS_MESSAGES: {
    STYLE_IMAGE_UPLOADED: 'スタイル参照画像がアップロードされました',
    IMAGE_GENERATION_COMPLETE: '画像生成に成功しました',
    ALL_IMAGES_GENERATED: '全ての画像生成に成功しました',
    VIDEO_GENERATION_COMPLETE: '動画生成が完了しました',
    VIDEO_COMBINATION_COMPLETE: '動画の結合が完了しました',
    VIDEO_EDIT_COMPLETE: '動画の編集が完了しました'
  },

  // 情報メッセージ
  INFO_MESSAGES: {
    GENERATING_VIDEO_FROM_SCENES: (count: number) => `${count}つのシーンから動画を生成します`,
    SCENES_GENERATED: (count: number) => `${count}つのシーン動画が生成されました`,
    COMBINING_VIDEOS: 'シーン動画を結合しています...'
  }
};